import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { RfButton, HelperText } from '../..'

const InputFile = forwardRef(function InputFile(props, ref) {
	const { accept, disabled, fullWidth, helperText, inputRef, error, label, multiple = false, onChange } = props

	const handleChange = (e) => {
		onChange && onChange(e)
	}

	return (
		<div ref={ref} className="Vb-input-file">
			<RfButton
				className="Vb-input-file--label"
				component="label"
				disabled={disabled}
				fullWidth={fullWidth}
				icon="attach"
				variant="ghost"
			>
				{label}
				<input type="file" accept={accept} ref={inputRef} multiple={multiple} onChange={handleChange} hidden />
			</RfButton>
			{helperText && (
				<div>
					<HelperText isError={error}>{helperText}</HelperText>
				</div>
			)}
		</div>
	)
})

export default InputFile

InputFile.propTypes = {
	/**
	 * One or more unique file type specifiers describing file types to allow.
	 */
	accept: PropTypes.string,

	/**
	 * If `true`, the input is disabled.
	 * @default false
	 */
	disabled: PropTypes.bool,

	/**
	 * If `true`, the button is full width.
	 * @default false
	 */
	fullWidth: PropTypes.bool,

	/**
	 * Text that is displayed below the input.
	 */
	helperText: PropTypes.string,

	/**
	 * Pass a ref to the `input` element.
	 */
	inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

	/**
	 * If `true`, the `input` will indicate an error.
	 */
	error: PropTypes.bool,

	/**
	 * The text to be used in an enclosing label element.
	 */
	label: PropTypes.node,

	/**
	 * If `true`, `input` accepts more than one file.
	 */
	multiple: PropTypes.bool
}
